/**
* @ngdoc directive
* @name Mobile Filters
*
* @description
  Mobile Filters displayed as filter icon
  On icon click:
  * on desktop show aside
  * on mobile show actions selector
*
* @scope
* @param {Object} filters - with Actions name and url to filters to display
*
* @example
  <mobile-filters></mobile-filters>
*/

(function () {
  'use strict';

  directive.$inject = ["PATH", "overflowHiddenService"];
  app.directive('mobileFilters', directive);

  function directive(PATH, overflowHiddenService) {
    return {
      restrict: 'E',
      link: link,
      templateUrl: PATH.components + 'mobilefilters/template.html'
    };

    function link($scope) {
      $scope.areFiltersVisible = false;
      $scope.toggleFilters = function () {
        $scope.areFiltersVisible = !$scope.areFiltersVisible;

        overflowHiddenService.toggle('body', $scope.areFiltersVisible);
      };
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/mobilefilters/directive.js